const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
const preSalePlan = {
  // 销售定位下拉&&销售定位列表
  rankingExport: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/store/rankingExport`
  },
  // 列表下载
  downloadTabList: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/downloadTabList`
  },
  // 销售定位下拉&&销售定位列表
  planSaleList: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/saleList`
  },
  // 销售定位 新增
  planSaleInsert: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/saleInsert`
  },
  // 销售定位 编辑
  planSaleUpdate: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/saleUpdate`
  },
  // 销售定位 修改状态（启停）
  planSaleUpdateStatus: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/saleUpdateStatus`
  },
  // 店铺下拉（顶部）
  planGetShop: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/getShop`
  },
  // 店铺权限下拉
  planGetStoreNameOptions: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/getStoreNameOptions`
  },
  // A类新品店铺下拉
  storeSelect: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/newProductA/storeSelect`
  },
  // 店铺权限分页
  planUserDatalistPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/userDatalistPage`
  },
  // 店铺权限新增
  planInsertUserData: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/insertUserData`
  },
  // 店铺权限编辑
  planEditUserData: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/editUserData`
  },
  // 店铺权限删除
  planDeleteUserData: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/deleteUserData`
  },
  // 查询提报店铺
  planReportShop: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/reportShop`
  },
  // 修改提报店铺状态
  planUpdateReportShop: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/updateReportShop`
  },

  // 预估节点 列表查询
  predictionNodeListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/predictionNode/listPage`
  },
  // 预估节点 新增节点
  predictionNodeAdd: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/predictionNode/add`
  },
  // 预估节点 编辑节点
  predictionNodeModify: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/predictionNode/modify`
  },
  // 预估节点 删除节点
  predictionNodeMove: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/predictionNode/move`
  },

  // 提报节奏 获取
  planSubmitTypeGet: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/submit/type/get`
  },
  // 提报节奏 修改
  planSubmitTypeModify: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/submit/type/modify`
  },

  // 月等级
  planProductGrade: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/productGrade`
  },

  // 未提报-包件列表查询
  prePlanPackUnSubListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/prePlanPack/unSub/listPage`
  },
  // 已提报-包件列表查询
  prePlanPackSubListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/prePlanPack/sub/listPage`
  },
  // 全平台-未提报-包件编辑
  prePlanPackUnSubEdit: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/prePlanPack/unSub/edit`
  },
  // 包件历史销量
  packHistorySalesNum: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/packHistorySalesNum`
  },
  // 包件信息导出
  packExport: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/pack/export`
  },

  // 未提报-商品-列表查询
  goodsUnsubListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goods/unsub/listPage`
  },
  // 已提报-商品-列表查询
  goodsResultListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goods/result/listPage`
  },
  // 未提报-商品-编辑
  goodsUnsubModify: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goods/unsub/modify`
  },
  // 商品历史销量
  goodsHistorySalesNum: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goodsHistorySalesNum`
  },
  // 商品信息导出
  goodsExport: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goods/export`
  },

  // 产品列表查询
  productSubListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/product/sub/listPage`
  },
  // 产品历史预估详情-列表
  productResultListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/product/result/listPage`
  },

  // 月预估分析 散点图
  monthlyAnalysis: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/monthly/analysis`
  },
  // 月预估分析 饼图
  monthlyPieChart: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/monthly/pieChartInside`
  },
  // 日预估分析 柱状图
  dailyAnalysis: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/Daily/analysis`
  },

  // 提报概况
  goodsSubSim: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/goods/subSim`
  },
  // 提报
  planSubmit: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/submit`
  },
  // 获取预估节点信息
  predictionNodeGet: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/predictionNode/get`
  },
  // 店铺等级
  planShopGrade: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/shopGrade`
  },
  // 列表下载
  downloadList: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/downloadList`
  },
  // 店铺提报情况列表
  storeSubmissionList: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/storeSubmissionList`
  },
  // 销售目标
  salesTarget: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/salesTarget`
  },
  // 包件状态查询
  planPackStatus: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/packStatus`
  },
  // 包件编码下拉
  getPackCodeList: {
    type: 'post',
    url: `${apiName}/pack/getPackCodeList`
  },
  // 包件名称下拉
  getPackNameList: {
    type: 'get',
    url: `${apiName}/pack/getPackNameList`
  },
  // 在产状态编辑
  batchUpdatePackStatus: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/batchUpdatePackStatus`
  },
  // 修改实际销量
  getStoreSaleNumList: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/getStoreSaleNumList`
  },
  // 已提报-商品-编辑
  goodsSubModify: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goods/sub/modify`
  },
  // 各店铺产品预销差异分析
  getStorePreDiffData: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/getStorePreDiffData`
  },
  // 各店铺预估及实销数据分析
  getStoreAnalysisData: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/getStoreAnalysisData`
  },
  // 查询白名单（小件）
  getWhiteListByDate: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/getWhiteListByDate`
  },
  // 新品
  newProductResultListPage: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/new/product/result/listPage`
  },
  newProductSalesDetailList: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/new/product/salesDetailList`
  },
  // 首批量编辑
  firstBatchEdit: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/firstBatchEdit`
  },
  // 预销计划-已提报-产品-编辑
  productSubModify: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/product/sub/modify`
  },
  // 查询是否全部提报
  getAllIsSubmit: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/getAllIsSubmit`
  },
  // 新增小件、一个或则多个
  addSmallPiece: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/addSmallPiece`
  },
  // 预销计划-A类新品列表查询
  getNewProductA: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/getNewProductA`
  },
  // 预销计划-A类新品列表导出
  exportNewProductA: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/export/newProductA`
  },
  // 获取用户列表
  planUsers: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/users`
  },
  // 未提报产品导出
  listPagExcel: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/product/sub/listPagExcel`
  },
  // 未提报商品导出
  listPageExcel: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goods/unsub/listPageExcel`
  },
  // 获取各个类型销量数据最新的刷新时间
  getDataRenewal: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/getDataRenewal`
  },
  // 查询各个月份的提报店铺
  getMonthStore: {
    type: 'get',
    url: `${apiName}/pre-sale/plan/getMonthStore`
  },
  // 查询各个月份的提报店铺
  goodSubModify: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/goods/sub/modify`
  },
  // 查询全平台-商品-产品预估调整弹窗列表
  getPlanAdjustList: {
    type: 'post',
    url: `${apiName}/pre-sale/plan/getPlanAdjustList`
  },
  // 查询全平台-商品-产品预估调整弹窗列表
  getShopIsSubmit: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/getShopIsSubmit`
  },
 //基础配置-考核规则-查询
  assessmentRulesList: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/assessmentRulesList`
  },
  //基础配置-考核规则-修改
  updateAssessmentRule: { 
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/update/assessmentRule`
  },
  //基础配置-考核规则-新增
  addAssessmentRule: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/add/assessmentRule`
  },
  //基础配置-考核规则-删除
  delAssessmentRule: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/del/assessmentRule`
  },
  //预估监控-店铺排名-查询
  rankingList: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/store/rankingList`
  },
  //预估监控-预估分析-趋势图表
  analysisTrendChart: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/analysis/trendChart`
  },
  //预估调整量维护-开关状态获取
  switchGet: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/adjustment/switch/get`
  },
  //全平台权限人员调整预估调整量维护开关
  switchModify: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/adjustment/switch/modify`
  },
  //首批量删除
  firstBatchDel: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/firstBatch/del`
  },
  //平台分类-新增-编辑
  saveOrUpdate: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/platCategory/saveOrUpdate`
  },
  //平台分类-删除
  platCategoryDel: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/platCategory/del`
  },
  // 预销产品分类配置-分页查询
  preSaleProductCategoryListPage: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/product-category/listPage`
  },
  // 预销产品分类统计-分类选项
  preSaleProductCategoryOptions: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/product-category/options`
  },
  // 预销产品分类配置-新增
  preSaleProductCategorySave: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/product-category/save`
  },
  // 预销产品分类配置-编辑
  preSaleProductCategoryUpdate: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/product-category/update`
  },
  // 预销产品分类配置-删除
  preSaleProductCategoryDelete: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/product-category/delete`
  },
  // 预估调整量导出
  planAdjustExport: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/planAdjust/export`
  },
  // 预销产品分类统计-汇总分页
  preSaleProductCategorySummaryListPage: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/category/summary/listPage`
  },
  // 预销产品分类统计-店铺明细导出
  preSaleProductCategoryDetailExport: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/category/detail/export`
  },
  // 预销店铺统计-汇总分页
  preSaleShopSummaryListPage: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/shop/summary/listPage`
  },
  //直播计划商品列表查询
  planLiveOrderListPage: {
    type: 'post',
    url: `/ec-pc-api/planLiveOrder/listPage`
  },
  //直播计划商品删除
  planLiveOrderDelete: {
    type: 'post',
    url: `/ec-pc-api/planLiveOrder/delete`
  },
  //直播计划包件删除
  planLiveOrderDeletePack: {
    type: 'post',
    url: `/ec-pc-api/planLiveOrder/deletePack`
  },
  //直播计划产品删除
  planLiveOrderDeleteProduct: {
    type: 'post',
    url: `/ec-pc-api/planLiveOrder/deleteProduct`
  },
  //回退提报
  planRollBack: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/rollBack`
  },
  //回退提报-获取展示标识
  planRollBackGetShowFlag: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/rollBack/getShowFlag`
  },
  //预估调整量维护开关季度
  switchQuarterModify: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/adjustment/switch/quarter/modify`
  },
  //预估调整量季度维护开关状态获取
  switchQuarterGet: {
    type: 'get',
    url: `/ec-pc-api/pre-sale/plan/adjustment/switch/quarter/get`
  },
  //预销计划-提报回退
  planRollback: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/rollback`
  },
  //预销计划-预销计划-回退记录-列表
  planRollbackListPage: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/rollback/listPage`
  },
  //清除预销计划缓存
  clearPrePlanCache: {
    type: 'post',
    url: `/ec-pc-api/pre-sale/plan/clearPrePlanCache`
  },
  //预销计划-结果-商品-列表查询
  newGoodsResultListPage: {
    type: 'post',
    url: '/ec-pc-api/pre-sale/plan/new/goods/result/listPage',
  },
  //预销计划-上市清单-列表查询
  goodsQueryListNo: {
    type: 'get',
    url: '/ec-pc-api/pre-sale/plan/new/goods/queryListNo',
  },
  summaryExport: {
    type: 'post',
    url: '/ec-pc-api/pre-sale/plan/category/summary/export',
  },

}

export default preSalePlan;
